import React from 'react';
import { H4, Text } from '@amzn/atoz-web/Text';
import { useTranslation } from 'react-i18next';
import { getWeekIntervalString } from '@amzn/atoz-shiftapp-utilities';
import { DateTime } from 'luxon';
import { View } from '@amzn/atoz-web/View';
export var WeeklySummaryHeader = function (_a) {
    var displayProgress = _a.displayProgress, maxDuration = _a.maxDuration, associateName = _a.associateName;
    var t = useTranslation().t;
    return (React.createElement(View, { dataTestId: "WeeklySummaryHeader" }, displayProgress ? (React.createElement(React.Fragment, null,
        React.createElement(H4, { fontSize: "T300", fontWeight: "bold", dataTestId: "WeeklySummaryHeaderWeek", margin: { bottom: 'S100' } },
            t('ess_shifts_dashboard_weeklySummary_yourWeek'),
            ' ',
            getWeekIntervalString(DateTime.local())),
        React.createElement(Text, { fontSize: "T200", dataTestId: "WeeklySummaryHeaderMaxHours" }, "".concat(maxDuration === null || maxDuration === void 0 ? void 0 : maxDuration.toFixed(0), " "),
            t('ess_shifts_dashboard_weeklySummary_hoursMax')))) : (React.createElement(H4, { fontWeight: "bold", dataTestId: "WeeklySummaryHeaderWelcome" }, !!associateName
        ? t('ess_shifts_dashboard_weeklySummary_welcomeAssociate', { associate: associateName })
        : t('ess_shifts_dashboard_weeklySummary_welcome')))));
};
